import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import DemoEnvironmentBanner from 'components/DemoEnvironmentBanner';
import AppNavbar from './AppNavbar';
import AppSidebar from './AppSidebar';

const APP_BAR_MOBILE = 64;
// Keep in sync with APPBAR_DESKTOP in ./AppNavbar.js — this clears the fixed bar.
const APP_BAR_DESKTOP = 72;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 16,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 16,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function AppLayout({ currentPage }) {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      <AppSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} currentPage={currentPage} />
      <AppNavbar onOpenSidebar={() => setOpen(true)} />
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex,
          }),
          ...(collapseClick && {
            ml: '102px',
          }),
        }}
      >
        <DemoEnvironmentBanner sx={{ mb: 2 }} />
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
